import React from "react";

export type TimelineItem = {
  id: number | string;
  label: string;
  date?: string;
  details?: string;
};

type Props = {
  steps: TimelineItem[];
  currentStep: number; // 0-based index
  className?: string;
};

const TimelineUI: React.FC<Props> = ({
  steps,
  currentStep,
  className = "",
}) => {
  return (
    <div
      className={`w-full p-4 overflow-hidden overflow-x-auto whitespace-nowrap  bg-white shadow-sm border border-gray-200 rounded-2xl space-y-4 ${className}`}
    >
      {" "}
      <h2 className="text-lg font-semibold mb-4 text-gray-800">Timeline</h2>
      <div className="flex items-center justify-between relative">
        {steps.map((item, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;

          return (
            <div
              key={item.id}
              className="flex-1 flex flex-col items-center relative"
            >
              {/* LINE */}

              {index !== steps.length - 1 && (
                <div
                  className={`absolute top-2.5 left-1/2 w-full h-[2px] z-0 ${
                    index < currentStep ? "bg-green-500" : "bg-gray-300"
                  }`}
                />
              )}

              {/* CIRCLE */}
              <div
                className={`z-10 w-6 h-6 rounded-full flex items-center justify-center border ${isCompleted ? "bg-green-500 border-green-500" : isCurrent ? "bg-[#FBD037] border-[#FBD037]" : "bg-white border-gray-300"}`}
              >
                {isCompleted && (
                  <svg
                    className="w-3 h-3 text-white"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={3}
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}

                {isCurrent && <div className="w-2 h-2 bg-white rounded-full" />}
              </div>

              {/* TEXT */}
              <div className="mt-1 text-center px-2 cursor-pointer relative group">
                <p
                  className={`text-sm font-medium ${isCompleted || isCurrent ? "text-black" : "text-gray-400"}`}
                >
                  {item.label}
                </p>

                {item?.details && (
                  <div
                    className={`absolute flex justify-center items-center -top-16  mt-2 opacity-0 group-hover:opacity-100 transition duration-200 z-50 ${index === 0 ? "left-0 translate-x-0" : index === steps.length - 1 ? "right-0 translate-x-0" : "left-1/2 -translate-x-1/2"}`}
                  >
                    <div className="bg-black  rounded-md px-3 py-1 space-y-1 shadow-lg whitespace-nowrap">
                      <p className="text-white text-xs">{item.details}</p>
                      {item.date && (
                        <p className="text-xs text-white">{item.date}</p>
                      )}
                    </div>

                    {/* ARROW */}
                    <div
                      className={`w-2 h-2 bg-black rotate-45 absolute -bottom-1 ${index === 0 ? "left-3" : index === steps.length - 1 ? "right-3" : "left-1/2 -translate-x-1/2"}`}
                    ></div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimelineUI;
